const ENVS = {
	API_URL: 'https://api.distribuidoresfluke.com.br/',
	MKT_URL: 'https://marketing.distribuidoresfluke.com.br/',
}

module.exports = ENVS
